<template>
    <v-app id="app" dark>
        <router-view/>
        <v-snackbar v-model="snackbar" bottom :timeout="timeout" dark>
            {{ $t('song-not-saved') }}
            <v-btn dark flat color="accent" @click.stop="snackbar = false">
                {{ $t('close') }}
            </v-btn>
        </v-snackbar>
    </v-app>
</template>

<script>
import store from '@/stores';

export default {
    store,
    data: function()
    {
        return {
            snackbar: false,
            timeout:  6000,
        };
    },
    mounted: function()
    {
        // Avant chaque changement de route, on vérifie que la chanson est enregistrée
        // ---------------------------------------------------------------------------
        this.$router.beforeEach((to, from, next) =>
        {
            if (store.getters.isSongModified !== undefined && !store.getters.isSongModified)
            {
                next();
            }
            else
            {
                this.snackbar = true;
            }
        });
    },
};
</script>

<style scoped lang="scss">
    #app {
        font-family:             'Roboto', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing:  antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align:              center;
        color:                   #efefef;
        overflow:                hidden;
    }
</style>
